(function () {
  'use strict';
  window.snrUpsellAdd = function (btn, variantId) {
    if (btn.classList.contains('loading') || btn.classList.contains('done')) return;
    btn.classList.add('loading');
    var orig = btn.textContent;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) { btn.classList.remove('loading'); btn.textContent = orig; return; }
      btn.classList.remove('loading');
      btn.classList.add('done');
      btn.textContent = '✓ Toegevoegd';
      if (window.SHTHelper && typeof SHTHelper.forceUpdateCartStatus === 'function') {
        SHTHelper.forceUpdateCartStatus({ id: parseInt(variantId, 10) });
      }
      fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
        document.querySelectorAll('.js-cart-count,.header__cart-count').forEach(function(el){ el.textContent = cart.item_count; });
      });
    })
    .catch(function () { btn.classList.remove('loading'); btn.textContent = orig; });
  };
})();
